import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="threeds-poller"
//
// Used by the direct sale checkout page when the payment is in
// pending_threed_secure status within the retry window. Polls the status
// endpoint to redirect the customer as soon as the e-Rede postback finalizes
// the transaction, and reloads the page when the retry-at timestamp is
// reached so the customer sees a fresh, enabled checkout form.
export default class extends Controller {
  static targets = ["countdown"]
  static values = { statusUrl: String, retryAt: String }

  connect() {
    this.retryAtMs = Date.parse(this.retryAtValue)
    this.tick()
    this.timer = setInterval(() => this.tick(), 1000)
    this.poller = setInterval(() => this.checkStatus(), 3000)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
    if (this.poller) clearInterval(this.poller)
  }

  tick() {
    const remaining = Math.max(0, Math.floor((this.retryAtMs - Date.now()) / 1000))

    if (this.hasCountdownTarget) {
      const m = Math.floor(remaining / 60)
      const s = String(remaining % 60).padStart(2, "0")
      this.countdownTarget.textContent = `${m}:${s}`
    }

    if (remaining <= 0) {
      window.location.reload()
    }
  }

  async checkStatus() {
    try {
      const response = await fetch(this.statusUrlValue, {
        headers: { Accept: "application/json" }
      })
      if (!response.ok) return

      const data = await response.json()
      if (data && data.redirect_url) {
        window.location.href = data.redirect_url
      } else if (data && data.status && data.status !== "pending_threed_secure") {
        window.location.reload()
      }
    } catch (_) {
      // Network errors during polling are silently ignored — next tick retries.
    }
  }
}
